import React from "react";
import ControlKpiTile from "../../cost-control/ControlKpiTile";
import AnalyzerChart from "../../cost-analyzer/AnalyzerChart";
import { fmtSignedMoney, fmtMoney } from "../format";

const CLASS_LABEL = { volume_growth: "Volume growth", price_change: "Price change", new_resource: "New resource", mixed: "Mixed", unknown: "Unknown" };
const BUDGET = { over: { label: "Forecast breach", tone: "critical" }, at_risk: { label: "At risk", tone: "attention" }, ok: { label: "Within budget", tone: "ok" } };

export default function ImpactTab({ version }) {
  const impact = version?.impact;
  if (!impact) return <div className="text-text-3">No impact computed yet — use Re-run.</div>;
  const { monthlyRunRateDelta, operational, forecast, budget } = impact;
  const bud = budget ? (BUDGET[budget.status] || BUDGET.ok) : null;

  const tiles = [
    { key: "rr", label: "Monthly run-rate impact", value: fmtSignedMoney(monthlyRunRateDelta), tone: monthlyRunRateDelta > 0 ? "attention" : "ok", href: "#" },
    { key: "n30", label: "Next 30-day impact", value: forecast?.available ? fmtMoney(forecast.projectedSpend) : "—", tone: "neutral", href: "#" },
    { key: "vb", label: "Forecast vs baseline", value: forecast?.available && forecast.p90DeltaVsBaseline != null ? fmtSignedMoney(forecast.p90DeltaVsBaseline) : "—", tone: "neutral", href: "#" },
    { key: "budget", label: "Budget consequence", value: bud ? bud.label : "No budget", tone: bud ? bud.tone : "neutral", href: "#" },
  ];

  return (
    <>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {tiles.map((t) => <ControlKpiTile key={t.key} tile={t} />)}
      </div>

      {forecast?.available && Array.isArray(forecast.series) && forecast.series.length > 1 && (
        <div className="rounded-card border border-card-bd bg-card p-5">
          {/* Same single-series diagnostic chart as the cost analyzer's "Daily spend":
              solid Actual, dashed Forecast, a light 90% range band, the forecast-start
              rule, an avg/day reference, and a peak annotation. The investigation's
              impact.forecast.series already matches AnalyzerChart's {date,actual,forecast,
              lower,upper} forecast shape, so it feeds straight in (spendDetails empty). */}
          <AnalyzerChart isSingleSeries forecast={forecast.series} />
        </div>
      )}

      <div className="rounded-card border border-card-bd bg-card p-5">
        <div className="text-[13px] font-semibold text-text-2">Operational change detected</div>
        <div className="mt-1 text-[14px] text-text-2">
          <span className="font-medium">{CLASS_LABEL[operational?.classification] || "Unknown"}</span>
          {operational?.rationale ? ` — ${operational.rationale}` : ""}
        </div>
      </div>
    </>
  );
}
